<template>
  <div>
    <div class="page-top">
      <div class="container">
        <div class="row gx-4 gx-lg-5 justify-content-center">
          <div class="col-lg-8 col-xl-8 text-center">
            <h2 class="mt-0 mb-5 list-main-title">
              お問い合わせ
            </h2>
            <p class="text-silence mb-3">
              よくある質問を確認しても解決しない場合は、お気軽にお問い合わせください。<br>
              <span class="text-pure-black">&#40;受付時間 平日10&#8758;00〜20&#8758;00&#41;</span>
            </p>

            <!--SNS ICON-->
            <a
              href="mailto:affiliates@katsuwin.ai"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_email.png"
            ></a>
            <a
              href="https://twitter.com/katsuwinonline"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_twitter.png"
            ></a>
            <a
              href="https://www.youtube.com/@Katsuwinonline"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_youtube.png"
            ></a>
            <a
              href="https://www.instagram.com/katsuwinonline/"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_ig.png"
            ></a>
          </div>
        </div>

        <div class="col-lg-6 col-md-9 mx-auto rounded pt-4">
          <form class="form-style">
            <div class="mb-3">
              <div class="mb-3">
                <label for="name" class="form-label ms-3">氏名</label>
                <input
                  id="name"
                  v-model="postForm.firstName"
                  type="text"
                  class="form-control"
                  aria-describedby="nameHelp"
                  placeholder="ご登録のお名前をご記入ください"
                  @input="checkField('firstName')"
                >
                <div v-show="showFieldError('firstName')" id="namelHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- name -->

              <div class="mb-3">
                <label for="account" class="form-label ms-3">メールアドレス</label>
                <input
                  id="account"
                  v-model="postForm.email"
                  type="text"
                  class="form-control"
                  aria-describedby="accountHelp"
                  placeholder="メールアドレスをご記入ください "
                  @input="checkField('email')"
                >
                <div v-show="showFieldError('email')" id="accountHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- title -->

              <div class="mb-3">
                <label for="ForTitle" class="form-label ms-3">タイトル</label>
                <input
                  id="ForTitle"
                  v-model="postForm.title"
                  type="text"
                  class="form-control"
                  aria-describedby="EmailHelp"
                  placeholder="タイトルをご記入ください"
                  @input="checkField('title')"
                >
                <div v-show="showFieldError('title')" id="ForTitleHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- eMail -->

              <div class="mb-3">
                <label for="FormControlTextarea" class="form-label ms-3">メッセージ</label>
                <textarea
                  id="FormControlTextarea"
                  v-model="postForm.feedBack"
                  class="form-control text-area"
                  rows="3"
                  placeholder="お問い合わせ内容をご記入ください。"
                  @input="checkField('feedBack')"
                />
                <div v-show="showFieldError('feedBack')" id="FormControlTextarea" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- textarea -->
            </div>
            <!-- <div class="my-5 form-check">
							<input type="checkbox" class="form-check-input" id="exampleCheck1" />
							<label class="form-check-label" for="exampleCheck1"
								><a class="links" href="conditions.html" target="_self">利用規約</a
								>に同意する</label
							>
						</div> -->
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-primary btn-golden"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                :disabled="!isFormValid"
                @click="submitEmail"
              >
                送信
              </button>
            </div>
            <div
              id="exampleModal"
              class="modal fade"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5
                      id="exampleModalLabel"
                      class="modal-title"
                    >
                      勝win
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div class="modal-body my-5 text-center">
                    <p>
                      情報の受付を完了いたしました。<br>
                      当サイトからの連絡をお待ちくださいませ。
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary btn-golden"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <!-- <button type="button" class="btn btn-primary btn-golden"> changes</button> -->
                  </div>
                </div>
              </div>
            </div>
          </form>
          <!-- form End -->
          <div
            id="loading"
            class="text-danger mt-3 d-none"
          >
            情報は送信されました。
          </div>
          <div
            id="form_alerts"
            class="mt-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProxyEmail } from '@/api/event'

export default {
  data() {
    const postForm = {
      firstName: null,
      email: null,
      title: null,
      feedBack: null
    }
    return {
      postForm,
      mailVer: process.env.VUE_APP_MAIL_VER,
      mailAddress: process.env.VUE_APP_ENV === 'production' ? 'prod' : process.env.VUE_APP_TEST_MAIL,
      testMail: '',
      GASUrl: '',
      isChecked: false,
      initialValues: {},
      fieldErrors: {}

    }
  },
  computed: {
    isFormValid() {
      return (
        this.postForm.firstName &&
        this.postForm.email &&
        this.postForm.title &&
        this.postForm.feedBack
      )
    }

  },
  created() {
    this.initialValues = JSON.parse(JSON.stringify(this.postForm))
  },
  methods: {
    checkField(field) {
      // Check if the input field is empty and the value has been modified
      this.$set(this.fieldErrors, field, this.postForm[field] === '' && this.postForm[field] !== this.initialValues[field])
    },
    showFieldError(field) {
      return this.fieldErrors[field]
    },
    async submitEmail() {
      const messageData = `1.氏名：${this.postForm.firstName};;2.メールアドレス：${this.postForm.email};;3.タイトル :${this.postForm.title};;4.メッセージ：${this.postForm.feedBack}`
      const encodedMessage = encodeURIComponent(messageData)
      await new Promise((resolve) => {
        setTimeout(() => {
          this.GASUrl = 'https://script.google.com/macros/s/' + this.mailVer + '/exec?subject=' + encodeURIComponent('お問い合わせ') + '&env=' + this.mailAddress + '&message=' + encodedMessage
          resolve()
        }, 30)
      })
      getProxyEmail(this.GASUrl)
      this.postForm = {}
    }
  }
}
</script>
